import { DUE_SOON_PERCENT } from 'pages/MaintenancePage/constants';

export const TEST_ID = 'serviceUpcomingList';

export const PUMP_SEAL_DUE_PERCENT = DUE_SOON_PERCENT;
